/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useContext } from "react";
import * as React from "react";
import { LogoMode } from "./Logo";
import AppLayoutWrapper from "components/AppLayoutWrapper";

const AppLoadingContext = React.createContext(false);

export const useAppLoading = (): boolean => useContext(AppLoadingContext);

const AppLoading: React.FC<{ mode?: LogoMode }> = ({
  mode = LogoMode.DEFAULT,
}) => {
  return (
    <AppLoadingContext.Provider value={true}>
      <AppLayoutWrapper mode={mode}>
        <sp-progress-circle
          size="l"
          indeterminate
          aria-label={I18n.t("loading")}
        />
      </AppLayoutWrapper>
    </AppLoadingContext.Provider>
  );
};

export default AppLoading;
